import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Field, Form } from 'react-final-form';
import { EyeIcon, EyeOffIcon } from '@heroicons/react/solid';
import { composeValidators, renderField, required, email } from '../../helpers/form-validations';
import VinsytLogo from '../../assets/image/vinsyt-logo.svg';
import { callFBFunction, getRooftop, getRooftopConfig, setAuthToken } from '../../utils/firebase';
import withStateDispatch from '../../redux/withStateDispatch';

const Login = ({ setLoader, setNotify, setUser, setRooftop }) => {
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const onSubmit = (formData, form) => {
    setLoader(true);
    callFBFunction('staffLogin', formData)
      .then(async ({ data: response }) => {
        const { status, message, data } = response;
        if (!status) {
          setLoader(false);
          setNotify({ message, type: 'error' });
          return;
        }
        setAuthToken(data.access_token);
        setUser(data);
        const rooftopRes = await getRooftop();
        const rooftopConfig = await getRooftopConfig();
        setRooftop({
          ...rooftopRes,
          config: rooftopConfig
        });
        setNotify({ message, type: 'success' });
        form.reset();
        setLoader(false);
        if (data?.role.includes('sales')) {
          navigate('/inventory', {
            replace: true
          });
        } else {
          navigate('/redemption-history', {
            replace: true
          });
        }
      })
      .catch(() => {
        setLoader(false);
        setNotify({ message: 'Something went wrong', type: 'error' });
      });
  };
  return (
    <div className="max-w-screen-md mx-auto">
      <div className="h-[75px] flex flex-row justify-center items-center border-b-[2px] border-[#E4E7EB]">
        <img className="w-[95px] h-auto" src={VinsytLogo} alt="Vinsyt Logo" />
      </div>
      <h1 className="text-2xl font-semibold text-center py-12">Vinsyt Mobile</h1>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form className="mx-5 flex flex-col gap-5 h-full" onSubmit={handleSubmit}>
            <div className="flex flex-col gap-2">
              <label htmlFor="email" className="text-base font-medium">
                Email
              </label>
              <div>
                <Field
                  id="email"
                  type="text"
                  name="email"
                  component="input"
                  autoComplete="email"
                  className="w-[100%] rounded-md border border-[#555555] border-opacity-40 px-4 py-4 focus-visible:outline-none"
                  placeholder="eg: Johnny@hometown.com"
                  validate={composeValidators(required, email)}>
                  {renderField}
                </Field>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <label htmlFor="password" className="text-base font-medium">
                Password
              </label>
              <div className="relative w-100">
                <Field
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  component="input"
                  className="w-[100%] rounded-md border border-[#555555] border-opacity-40 px-4 py-4 focus-visible:outline-none"
                  placeholder="*****"
                  validate={composeValidators(required)}>
                  {renderField}
                </Field>
                <span
                  className="absolute top-5 right-5 cursor-pointer text-[#555555] text-opacity-40"
                  onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <EyeOffIcon width={20} /> : <EyeIcon width={20} />}
                </span>
              </div>
            </div>
            <div className="text-right">
              <Link className="text-[#5046E4] font-bold" to="/forgot-password">
                Forgot Password?
              </Link>
            </div>
            <button
              type="submit"
              className="w-full text-lg text-white bg-[#5046E4] rounded-md py-4 mt-2.5">
              Sign In
            </button>
          </form>
        )}
      />

      <div className="fixed bottom-5">
        <p className="text-[12px] text-tertiary px-5 mt-4">
          Looking for help? Contact JP Burkemper at{' '}
          <a className="text-[#5046E4]" href="tel:(970) 787-0551">
            (970) 787-0551
          </a>{' '}
          or email{' '}
          <a className="text-[#5046E4]" href="mailto:jp@vinsyt.com">
            jp@vinsyt.com
          </a>
        </p>
        <span className="text-sm text-tertiary mx-5 hidden md:block">
          Download the SA Mobile App for better experience
        </span>
      </div>
    </div>
  );
};

export default withStateDispatch(Login);
